/**
 * Calculate visible permission count (excluding managesUsers which is hidden from UI)
 * @param {Object} userPermissions - User permissions object
 * @returns {number} Number of visible permissions that are true
 */
export const getVisiblePermissionCount = (userPermissions = {}) => {
  const { ...visiblePermissions } = userPermissions;
  return Object.values(visiblePermissions).filter(value => value === true).length;
};
